<template>
  <div id="goods-detail">
    <!-- 商品详情 -->
    <div class="card">
      <div class="img-box">
        <img :src="host + goodsDetail.goodsPhoto" />
        <!-- <img src="@/static/images/home/pic.png" /> -->
      </div>
      <div class="info">
        <span class="title">{{ goodsDetail.name }}</span>
        <span>热销{{ goodsDetail.saleNum }}</span>
      </div>
      <div class="shuoming">
        <span>{{ goodsDetail.goodsDes }}</span>
      </div>
    </div>
    <!-- 商品描述 -->
    <div class="desc">
      <div class="tip">购买须知</div>
      <div class="desc-list">
        <!-- <p>1.有效期：2020.4.9至2020.9.30。</p>
        <p>2.每个账户兑换次数不限制。</p>
        <p>3.暂不支持地区：内蒙古、新疆、青海、西藏、港澳台等无法 到达地区。</p>
        <p>
          4.温馨提示：<br />
          趣豆一经使用不支持退还，先到先得，对完即止。
        </p> -->
        <p>{{ goodsDetail.goodsDetail }}</p>
      </div>
    </div>
    <!-- 立即兑换 -->
    <div class="exchange">
      <span class="code green">{{ goodsDetail.score }}趣豆</span>
      <div class="btn">
        <mt-button size="large" type="primary" @click="exchange"
          >立即兑换</mt-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      goodsId: "", //商品id
      goodsDetail: {},
      comfirFlag:true
    };
  },
  mounted() {
    this.goodsId = this.$route.params.id;
    this.queryGoodsDetail();
  },
  methods: {
    //商品兑换接口
    exchange() {
      this.$messagebox({
        title: "提示",
        message: "是否确定立即兑换？",
        showCancelButton: true,
        confirmButtonText: "确定",
      }).then((action) => {
        if (action == "confirm") {
          if(!this.comfirFlag){
            return
          }
          this.comfirFlag = false
          this.post(this.apis.buyWithPoints, {
            memberId: this.userInfo.memberId,
            goodsId: this.goodsId,
          })
            .then((response) => {
              if (response.data.retCode == "SUCCESS") {
                this.comfirFlag = true
                this.$toast({
                  message: response.data.retMsg,
                  duration: 1000,
                });
                setTimeout(() => {
                  this.$router.push({
                    name: "ExchangeSuccess",
                    params: { id: this.goodsId },
                  });
                }, 800);
              } else {
                this.$toast({
                  message: response.data.retMsg,
                  duration: 1000,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          //取消
        }
      });
      return;
    },
    //查询商品详情接口
    queryGoodsDetail() {
      this.post(this.apis.queryGoodsDetail, {
        memberId: this.userInfo.memberId,
        goodsId: this.goodsId,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.goodsDetail = response.data.goods;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
};
</script>

<style lang="less" scoped>
#goods-detail {
  padding: 34px 30px 0;
  padding-bottom: 120px;
  .card {
    width: 646px;
    // height: 600px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(163, 163, 163, 0.45);
    border-radius: 10px;
    padding: 23px 22px 0;
    .img-box {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 646px;
        height: 373px;
        border-radius: 10px;
      }
    }
    .info {
      color: #3a3a3a;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 90px;
      .title {
        flex: 0 0 500px;
        font-weight: bold;
        font-family: PingFang-SC-Bold;
        font-size: 32px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span {
        font-family: PingFang-SC-Regular;
        font-size: 24px;
      }
    }
    .shuoming {
      padding-bottom: 20px;
    }
  }
  .desc {
    margin-top: 36px;
    width: 644px;
    height: 347px;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(163, 163, 163, 0.45);
    border-radius: 10px;
    padding: 0 23px;
    .tip {
      line-height: 90px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      font-size: 30px;
      color: #3a3a3a;
    }
    .desc-list {
      position: relative;
      top: -6px;
      p {
        font-family: PingFang-SC-Regular;
        font-size: 24px;
        line-height: 40px;
        color: #3a3a3a;
      }
    }
  }
  .exchange {
    position: fixed;
    left: 0;
    bottom: 101px;
    width: 100%;
    height: 101px;
    background-color: #f1f1f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .code {
      padding-left: 50px;
      width: 300px;
      height: 30px;
      font-family: PingFang-SC-Bold;
      font-size: 32px;
      font-weight: bold;
      color: #1fbe6e;
    }
    .btn {
      padding-right: 45px;
      .mint-button--large {
        width: 224px;
        height: 70px;
      }
    }
  }
}
.mint-msgbox-message {
  padding-top: 30px;
  padding-bottom: 20px;
}
</style>
